const flags = {
  loginDemo: false
};
export default flags;
